import styled from "styled-components";

// Define the styled components based on the CSS classes

export const GridContainer = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-areas:
      "header lie3"
      "lie1 lie3 "
      "lie2 lie4 ";
    gap: 100px;
    background-color: #f1f1f1;
    padding: 10px;
    place-content: center;
    padding-top: 80px;
  }
`;

export const GridItem = styled.div`
  background-color: #f1f1f1;
  color: #000;
  padding: 10px;
  font-size: 30px;
  text-align: center;
`;

// Assign grid-area to each specific item
export const Header = styled(GridItem)`
  grid-area: header;
  padding: 48px 16px 16px 16px;
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.1px;
  @media (min-width: 768px) {
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 44px;
    font-style: normal;
    font-weight: 600;
    line-height: 56px;
    letter-spacing: -0.5px;
    max-width: 40vw;
    text-align: left;
    margin-left: 20px;
  }
`;

export const Lie1 = styled(GridItem)`
  grid-area: lie1;
  padding: 16px 20px;
  @media (min-width: 768px) {
    max-width: 40vw;
  }
`;

export const Lie2 = styled(GridItem)`
  grid-area: lie2;
  padding: 16px 20px;
  @media (min-width: 768px) {
    max-width: 40vw;
  }
`;

export const Lie3 = styled(GridItem)`
  grid-area: lie3;
  padding: 16px 20px;
  @media (min-width: 768px) {
    max-width: 40vw;
    align-self: end;
  }
`;

export const Lie4 = styled(GridItem)`
  grid-area: lie4;
  padding: 16px 20px;
  @media (min-width: 768px) {
    max-width: 40vw;
  }
`;
